// actions
import { CANCELBTN_UPDATE_LABEL } from './actions';

const CancelBtn = (
  state = {
    label: '',
  },
  action,
) => {
  switch (action.type) {
    case CANCELBTN_UPDATE_LABEL:
      return {
        ...state,
        label: action.label,
      };
    default:
      return state;
  }
};

export default CancelBtn;
